<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form
      v-if="isSearch"
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <el-form-item
        label="发送者"
        prop="senderUserId"
      >
        <GridSelect
          style="width: 180px"
          title="选择发送者"
          labelName='userName'
          labelValue='id'
          :value="queryForm.senderUserId"
          :limit="1"
          size="small"
          placeholder="请选择发送者"
          @getValue='(value) => {queryForm.senderUserId = value}'
          :columns="USER_code"
          :searchs="USER_search"
          dataListUrl="/mpp/user/findList"
          entityBeanName="mppUser"
          queryEntityUrl="/mpp/user/get"
        >
        </GridSelect>
      </el-form-item>
      <el-form-item
        label="接收者"
        prop="receiverUserId"
      >
        <GridSelect
          style="width: 180px"
          title="选择好友"
          labelName='userName'
          labelValue='id'
          :value="queryForm.receiverUserId"
          :limit="1"
          size="small"
          placeholder="请选择好友"
          @getValue='(value) => {queryForm.receiverUserId = value}'
          :columns="USER_code"
          :searchs="USER_search"
          dataListUrl="/mpp/user/findList"
          entityBeanName="mppUser"
          queryEntityUrl="/mpp/user/get"
        >
        </GridSelect>
      </el-form-item>
      <el-form-item label="消息内容">
        <el-input
          v-model="queryForm.messageContent"
          placeholder="请填写消息内容"
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-form-item label="消息类型">
        <el-select
          placeholder="请选择消息类型"
          clearable
          v-model="queryForm.messageType"
          style="width: 180px"
        >
          <el-option
            v-for="type in messageTypeList"
            :key="type.key"
            :label="type.value"
            :value="type.key"
          > </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="离线消息">
        <el-select
          placeholder="请选择离线消息"
          clearable
          style="width: 180px"
          size="small"
          v-model="queryForm.isOffline"
        >
          <el-option
            label="离线"
            :value="1"
          >
          </el-option>
          <el-option
            label="在线"
            :value="0"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          style="width: 180px"
          v-model="timeRange"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item style="margin-left: 80px">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getChatList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetDialog"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
        </div>
        <div class="icon-group">
          <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span
            class="icon-box"
            @click="refreshPrivateChatList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table
        :data="chatList"
        width="100%"
        row-key="id"
        size="small"
        height="100%"
        @selection-change="handleSelectionChange"
        :default-expand-all="true"
      >
        <el-table-column
          align="center"
          type="selection"
          min-width="5%"
        > </el-table-column>

        <el-table-column
          align="center"
          prop="senderUserId"
          label="发送者"
          min-width="12%"
        >
          <template slot-scope="scop">
            <div>{{ scop.row.sender ? scop.row.sender.userName : '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="receiverUser.userName"
          label="接收者"
          min-width="12%"
        >
        <template slot-scope="scop">
            <div>{{ scop.row.receiver ? scop.row.receiver.userName : '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="messageType"
          label="消息类型"
          min-width="10%"
        >
          <template slot-scope="scop">
            {{scop.row.messageType !== null ? getMessageDesc(scop.row.messageType) : '--'}}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="isOffline"
          label="离线消息"
          min-width="10%"
        >
          <template slot-scope="scop">
            {{scop.row.isOffline == 0 ? '在线' : '离线'}}
          </template>
        </el-table-column>
                <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="messageContent"
          label="消息内容"
          min-width="30%"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="创建时间"
          min-width="15%"
        >
          <template slot-scope="scop">
            {{$moment(scop.row.createTime).format('YYYY-MM-DD HH:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          min-width="10%"
        >
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkChat(scop.row.messageId)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
      <!-- 私聊消息详情 -->
      <el-dialog
        :title="'私聊消息详情'"
        :visible.sync="showDialog"
        width="50%"
        @close="closeDialog"
      >
        <div>
          <el-form
            :model="chat"
            ref="chatForm"
            :rules="rules"
            label-width="120px"
            :inline="true"
            size="mini"
          >
            <el-form-item
              label="发送者"
              prop="sendUserId"
              v-if="chat.sendUser !== null "
            >
              <el-input
                size="small"
                v-model="chat.sendUser.userName"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="接收者"
              prop="acceptUserId"
              v-if="chat.acceptUser !== null "
            >
              <el-input
                size="small"
                v-model="chat.acceptUser.userName"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="离线消息"
              prop="isOffline"
            >
              <el-select
                style="width : 175px"
                size="small"
                v-model="chat.isOffline"
                :disabled="true"
              >
                <el-option
                  label="在线"
                  :value="0"
                >
                </el-option>
                <el-option
                  label="离线"
                  :value="1"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="消息类型"
              prop="messageType"
            >
              <el-select
                style="width : 175px"
                size="small"
                v-model="chat.messageType"
                :disabled="true"
              >
                <el-option
                  v-for="messageType in messageTypeList"
                  :key="messageType.key"
                  :label="messageType.value"
                  :value="messageType.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="创建时间"
              prop="createTime"
            >
              <el-input
                size="small"
                v-model="$moment(chat.createTime).format('YYYY-MM-DD HH:mm:ss')"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="消息内容"
              prop="messageContent"
            >
              <el-input
                type="textarea"
                :rows="3"
                size="small"
                v-model="chat.messageContent"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div
          slot="footer"
          class="flex justify-end"
        >
          <el-button @click="closeDialog">关闭</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from "@/utils/constant"
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect
    },
    watch: {},
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            timeRange: [],
            queryForm: {
                senderUserId: '', //发送者id
                receiverUserId: '', //接收者id
                startTime: '', //开始时间
                endTime: '', //结束时间
                isOffline: '', //是否在线
                messageType: '', //消息类型
                messageContent: '' //消息内容
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentId: '', //当前id
            multipleSelection: [],
            chatList: [], //消息列表
            messageTypeList: [], //消息类型列表
            btnLoading: false,
            rules: {}, //规则
            chat: {
                acceptUser: {},
                acceptUserId: '',
                sendUser: {},
                sendUserId: '',
                createTime: '',
                isOffline: '',
                messageType: '',
                messageContent: '',
                messageId: ''
            }
        };
    },
    created() {
        this.getPrivateChatList();
        this.getMessageType();
    },
    methods: {
        //获取消息类型标签
        getMessageDesc(messageType) {
            for (const index in this.messageTypeList) {
                if (this.messageTypeList[index].key == messageType) {
                    return this.messageTypeList[index].value;
                }
            }
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        //查询
        getChatList() {
            this.getPrivateChatList();
        },
        //关闭窗口
        closeDialog() {
            this.resetDialog();
            this.resetProperty();
        },
        //私聊详细详情
        checkChat(currenctId) {
            this.showDialog = true; //对话框开启
            this.getChat(currenctId);
        },
        //获取消息详情
        getChat(id) {
            console.log(id);
            get(`/im/chatMessage/get`, { messageId: id }).then((res) => {
                if (res.success && res.code == 200) {
                    this.chat = { ...this.chat, ...res.chat };
                    console.log(res.chat);
                }
            });
        },
        //重置字段
        resetProperty() {
            this.chat = {
                acceptUser: {},
                acceptUserId: '',
                sendUser: {},
                sendUserId: '',
                createTime: '',
                isOffline: '',
                messageType: '',
                messageContent: '',
                messageId: ''
            };
        },
        //重置按钮
        resetDialog() {
            this.queryForm = {
                senderUserId: '',
                receiverUserId: '',
                startTime: '',
                endTime: '',
                isOffline: '',
                messageType: '',
                messageContent: ''
            };
            this.timeRange = [];
            this.showDialog = false;
            this.getPrivateChatList();
        },
        //获取私聊信息
        getPrivateChatList() {
            if(this.timeRange != null){
              this.queryForm.startTime = this.timeRange[0]
              this.queryForm.endTime = this.timeRange[1]
            }else{
              this.queryForm.startTime = ''
              this.queryForm.endTime = ''
            }
            get(`/im/friendmessage/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.chatList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        //获取消息类型
        getMessageType() {
            get(`/im/utils/getEnum`, { enumType: `friend_message_type` }).then((res) => {
                if (res.success) {
                    this.messageTypeList = res.enumList;
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getPrivateChatList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getPrivateChatList();
        },

        refreshPrivateChatList() {
            this.getPrivateChatList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.moneyRecord-table-expand {
    font-size: 0;
    margin-top: -20px;
}
.moneyRecord-table-expand label {
    width: 90px;
    color: #99a9bf;
}
.moneyRecord-table-expand .el-form-item {
    margin-left: 4%;
    margin-bottom: -1%;
    width: 100%;
}
</style>